import { render, staticRenderFns } from "./UpdateWalletModal.vue?vue&type=template&id=0ec451fb&scoped=true"
import script from "./UpdateWalletModal.vue?vue&type=script&lang=js"
export * from "./UpdateWalletModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateWalletModal.vue?vue&type=style&index=0&id=0ec451fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec451fb",
  null
  
)

export default component.exports